export default "<ion-app>\n  <app-side-menu></app-side-menu>\n  <ion-router-outlet id=\"main\"></ion-router-outlet>\n</ion-app>\n";